import React from 'react';
import useTranslate from '@hooks/useTranslate';
import { commonMessage } from '@locales/intl';
import { Modal, QRCode } from 'antd';

const QrCodeModal = ({ open, onClose, qrCodeUrl }) => {
    const translate = useTranslate();

    return (
        <Modal
            title={translate.formatMessage(commonMessage.qrCode)}
            open={open}
            onCancel={onClose}
            footer={null}
            destroyOnClose
            centered
        >
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {qrCodeUrl ? (
                    <QRCode value={qrCodeUrl} size={480} />
                ) : (
                    <span>No QR Code Available</span>
                )}
            </div>
        </Modal>
    );
};

export default QrCodeModal;